import 'regenerator-runtime/runtime';
import { call, select } from 'redux-saga/effects';

import { getThreeState, handleGenericError } from '../common';
import { setRenderFlag } from './animationFrame';

export default function* addTowerToScene(action) {
  try {
    const { scene } = yield select(getThreeState);
    if (!scene) return;
    const { tower } = action.payload;
    if (tower.mesh) {
      tower.mesh.visible = tower.visible;
      scene.add(tower.mesh);
    }
    setRenderFlag();
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
